import 'cookieconsent';
import { WistiaVideoCarousel } from './components/wistiaVideosCarousel.js';
import { ImageLinks } from './components/imageLinks.js';
import { CarouselStory } from './components/carousel-story.js';
import { Carousel } from './components/carousel.js';

$(document).ready(function () {
    WistiaVideoCarousel();
    ImageLinks();
    CarouselStory();
    Carousel();
})

$(document).foundation();